import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'lyceo-page-header',
  imports: [FontAwesomeModule],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  public title: InputSignal<string> = input.required();
  public subTitle: InputSignal<string | undefined> = input();
  public logo: InputSignal<boolean> = input(false);
  public backButton: InputSignal<boolean> = input(false);
  public readonly backButtonClicked: OutputEmitterRef<void> = output();

  protected readonly faChevronLeft: IconDefinition = faChevronLeft;
}
